import React, { useState } from "react";
import axios from "axios";
import GeneralHeader from "../components/GeneralHeader";
import Footer from "../components/Footer";
import "../styles/OrdersPage.css";
import "../styles/OrdersPage.mobile.css";   // mobile overrides
import { API_BASE_URL } from "../utils/api";
import useOrdersPageController from "../controllers/useOrdersPageController";
import currenyGreen from "../assets/images/currency_white_1.png";
import Swal from "sweetalert2";

/* ===== UI-only helpers/constants (kept) ================================== */
const sar = (n) => <span className="sar">
  {Number(n || 0).toLocaleString("ar-EG")}
  <img src={currenyGreen} alt="SAR" className="sar-icon" />
</span>;
function fmtDate(dtStr) {
  if (!dtStr) return "";
  try {
    const d = new Date(dtStr);
    return d.toLocaleString("ar-EG", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return dtStr;
  }
}
const TABS = [
  { key: "inprogress", label: "جاري" },
  { key: "completed", label: "اكتملت" },
  { key: "cancelled", label: "انلغت" },
];

/* ===== Page =============================================================== */
export default function OrdersPage() {
  const {
    tab, setTab,
    loading, err,
    filtered,
    canView,

    // guest gate
    guestPhone, setGuestPhone, guestLoaded, guestLoading, guestError, fetchByPhone,

    // details
    activeOrder, openOrderDetails, closeOrderDetails, markOrderCancelled,
  } = useOrdersPageController();

  return (
    <div className="orders-page" dir="rtl">
      <div className="clip-bg" aria-hidden="true" />

      <div className="orders-container">
        <h1 className="orders-title">طلبياتي</h1>

        {!canView && (
          <form className="guest-gate" onSubmit={fetchByPhone}>
            <div className="guest-row">
              <input
                type="tel"
                inputMode="tel"
                placeholder="أدخل رقم جوالك"
                value={guestPhone}
                onChange={(e) => setGuestPhone(e.target.value)}
                disabled={guestLoading}
              />
              <button type="submit" className="lime" disabled={guestLoading}>
                {guestLoading ? "..." : "طلبياتي"}
              </button>
            </div>
            <p className="hint">تقدر تشوف طلباتك بدون تسجيل دخول — فقط برقم جوالك.</p>
            {guestError && (
              <p className="hint" style={{ color: "#ff6b6b" }}>
                {guestError}
              </p>
            )}
          </form>
        )}

        {canView && (
          <>
            <div className="orders-tabs" role="tablist" aria-label="تصنيف الطلبات">
              {TABS.map((t) => (
                <button
                  key={t.key}
                  className={`tab ${tab === t.key ? "active" : ""}`}
                  role="tab"
                  aria-selected={tab === t.key}
                  onClick={() => setTab(t.key)}
                >
                  {t.label}
                </button>
              ))}
            </div>

            {loading && <div className="empty">جارٍ التحميل...</div>}
            {err && <div className="empty" style={{ color: "#ff6b6b" }}>{err}</div>}

            {!loading && !err && (
              <div className="orders-list">
                {filtered.length === 0 && (
                  <div className="empty">لا توجد طلبات في هذا التصنيف.</div>
                )}

                {filtered.map((o) => {
                  const statusLabel =
                    (o?.worker === "todo" || o?.worker === "aknowladge") && o?.status !== 'canceled'
                      ? "جاري تجهيز طلبك"
                      : o?.worker === "prepare done" && o?.status !== 'canceled'
                        ? "تم تجهيز طلبك"
                        : o?.worker === "shipped" && o?.status !== 'canceled'
                          ? "تم شحن طلبك"
                          : o?.worker === "delivered" && o?.status !== 'canceled'
                            ? "تم تسليم الطلب"
                            : "الطلب ملغي";


                  return (
                    <article
                      key={o.id}
                      className="order-card clickable"
                      dir="rtl"
                      tabIndex={0}
                      role="button"
                      onKeyDown={(e) => (e.key === "Enter" ? openOrderDetails(o) : null)}
                      onClick={(e) => {
                        if (e.target.closest(".btn, a, button")) return;
                        openOrderDetails(o);
                      }}
                    >
                      <div className="row top">
                        <div className="cell" style={{ maxWidth: "150px" }}>
                          <span className="k">عدد القطع:</span>
                          <span className="v">{o.qty || 0}</span>
                        </div>

                        <div className="cell">
                          <span className="k">السعر الإجمالي:</span>
                          <span className="v">{sar(o.totalPrice)}</span>
                        </div>

                        {o.tab === "inprogress" && (
                          <div className="cell">
                            <span className="k">الوقت المتوقع للتوصيل:</span>
                            <span className="v">{o.city === "الرياض" ? "خلال يوم عمل" : "خلال 1-3 أيام عمل"}</span>
                          </div>
                        )}

                        {o.tab === "completed" && (
                          <div className="cell">
                            <span className="k">تاريخ التسليم:</span>
                            <span className="v">{fmtDate(o.deliveredAt) || "—"}</span>
                          </div>
                        )}

                        {o.tab === "cancelled" && (
                          <div className="cell">
                            <span className="k">تاريخ الإلغاء:</span>
                            <span className="v">{fmtDate(o.cancelledAt || o.updatedAt) || "—"}</span>
                          </div>
                        )}
                      </div>

                      <div className="row bottom">
                        <div className="thumbs-wrap">
                          {(o.images || []).slice(0, 2).map((src, i) => (
                            <div key={i} className="thumbs">
                              <img src={src} alt={`order-${o.id}-img-${i + 1}`} />
                            </div>
                          ))}
                        </div>

                        <div className="left-group">
                          <button
                            type="button"
                            className="btn pill"
                            onClick={(e) => { e.stopPropagation(); openOrderDetails(o); }}
                            title="تفاصيل الطلبية"
                          >
                            تفاصيل الطلبية
                          </button>

                          <div className="status">
                            <span className="badge dim">{statusLabel}</span>
                          </div>
                        </div>
                      </div>
                    </article>
                  );
                })}


              </div>
            )}
          </>
        )}
      </div>

      {activeOrder && (
        <OrderDetailsModalV2
          order={activeOrder}
          onClose={closeOrderDetails}
          onCancelSuccess={(cartId) => {
            markOrderCancelled(cartId);
            // mirror your original behavior: also switch the tab to "cancelled"
            // tab switch is handled inside controller via markOrderCancelled + user UI
          }}
        />
      )}
    </div>
  );
}

/* ===== Modal v2 (with per-item cancel) ===== */
function OrderDetailsModalV2({ order, onClose, onCancelSuccess, onItemCancelSuccess }) {
  const token = localStorage.getItem("token");
  const [cancelling, setCancelling] = React.useState(false);
  const [confirming, setConfirming] = React.useState(false);
  const [localOrder, setLocalOrder] = React.useState(order);
  const [cancellingItemId, setCancellingItemId] = React.useState(null);

  // put this near the top of OrderDetailsModalV2 (above useEffects is fine)
  const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;
  function isCancelWindowOpen(o) {
    if (!o) return false;
    // Only restrict COMPLETED orders; in-progress can still be cancelled.
    if (o.tab !== "completed") return true;

    // Prefer deliveredAt; otherwise fall back to any date you store
    const deliveredStr = o.deliveredAt || o.arrivalAt || o.updatedAt;
    if (!deliveredStr) return true; // if we can't tell, don't block

    const deliveredTs = Date.parse(deliveredStr);
    if (Number.isNaN(deliveredTs)) return true;

    return Date.now() - deliveredTs < ONE_WEEK_MS;
  }

  React.useEffect(() => setLocalOrder(order), [order]);
  React.useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, []);

  // متى نُظهر أزرار الإلغاء والتأكيد؟
  const canCancel =
    localOrder?.tab === "inprogress" ||
    (localOrder?.tab === "completed" && isCancelWindowOpen(localOrder));
  const canConfirmReceived = localOrder?.tab === "inprogress";
  const disableConfirmReceived = localOrder?.worker != "shipped";

  const statusLabel =
    (localOrder?.worker === "todo" || localOrder?.worker === "aknowladge") && localOrder?.status !== 'canceled'
      ? "جاري تجهيز طلبك"
      : localOrder?.worker === "prepare done" && localOrder?.status !== 'canceled'
        ? "تم تجهيز طلبك"
        : localOrder?.worker === "shipped" && localOrder?.status !== 'canceled'
          ? "تم شحن طلبك"
          : localOrder?.worker === "delivered" && localOrder?.status !== 'canceled'
            ? "تم تسليم الطلب"
            : "الطلب ملغي";

  const fmt = (n) => (
    <span className="sar">
      {Number(n || 0).toLocaleString("ar-EG")}
      <img src={currenyGreen} alt="SAR" className="sar-icon" />
    </span>
  );

  const dateLabel =
    localOrder?.tab === "completed"
      ? "تاريخ التسليم"
      : localOrder?.tab === "cancelled"
        ? "تاريخ الالغاء"
        : "تاريخ الطلبيه"; // inprogress أو غيرها
  // تأكيد وصول الطلبية (يظهر فقط في تبويب جاري)
  const handleConfirmReceived = async () => {
    if (!localOrder?.cartId) {
      await Swal.fire({
        icon: "error",
        title: "تعذّر الإجراء",
        text: "تعذر العثور على رقم الطلب.",
        confirmButtonText: "حسناً",
        confirmButtonColor: "#CAEA3E",
        iconColor: "#CAEA3E",
        customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
      });
      return;
    }

    const { isConfirmed } = await Swal.fire({
      icon: "question",
      title: "تأكيد وصول الطلبيه",
      text: "هل وصلت الطلبية فعلًا وتود تأكيد الاستلام؟",
      showCancelButton: true,
      confirmButtonText: "نعم، تأكيد الاستلام",
      cancelButtonText: "تراجع",
      confirmButtonColor: "#CAEA3E",
      iconColor: "#CAEA3E",
      reverseButtons: true,
      customClass: {
        popup: "swal-dark-popup",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });

    if (!isConfirmed) return;

    try {
      setConfirming(true);

      // NOTE: عدّل المسار أدناه حسب واجهتك البرمجية
      const res = await axios.post(
        `${API_BASE_URL}/carts/confirm-received`,
        { cart_id: localOrder.cartId }
      );

      if (res?.data?.status === true || res?.status === 200) {
        // نحولها مكتملة محليًا (حتى لو ما رجع السيرفر تفاصيل)
        const updated = {
          ...localOrder,
          tab: "completed",
          deliveredAt: new Date().toISOString(),
        };
        setLocalOrder(updated);

        await Swal.fire({
          icon: "success",
          title: "تم التأكيد",
          text: "تم تأكيد وصول الطلبية بنجاح.",
          confirmButtonText: "حسناً",
          confirmButtonColor: "#CAEA3E",
          iconColor: "#CAEA3E",
          customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
        });
      } else {
        await Swal.fire({
          icon: "info",
          title: "تعذّر التأكيد",
          text: res?.data?.message || "تعذر تأكيد وصول الطلبية حالياً.",
          confirmButtonText: "حسناً",
          confirmButtonColor: "#CAEA3E",
          iconColor: "#CAEA3E",
          customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
        });
      }
    } catch (e) {
      await Swal.fire({
        icon: "error",
        title: "حدث خطأ",
        text: "حدث خطأ أثناء تأكيد الاستلام.",
        confirmButtonText: "حسناً",
        confirmButtonColor: "#CAEA3E",
        iconColor: "#CAEA3E",
        customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
      });
    } finally {
      setConfirming(false);
    }
  };

  // إلغاء الطلب بالكامل (يظهر فقط في جاري/اكتملت)
  const handleCancel = async () => {

    if (!localOrder?.cartId) {
      await Swal.fire({
        icon: "error",
        title: "تعذّر الإجراء",
        text: "تعذر العثور على رقم الطلب.",
        confirmButtonText: "حسناً",
        confirmButtonColor: "#CAEA3E",
        iconColor: "#CAEA3E",
        customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
      });
      return;
    }

    const { isConfirmed } = await Swal.fire({
      icon: "warning",
      title: "تأكيد الإلغاء",
      text: "هل تريد إلغاء هذا الطلب؟",
      showCancelButton: true,
      confirmButtonText: "نعم، إلغاء الطلب",
      cancelButtonText: "تراجع",
      confirmButtonColor: "#CAEA3E",
      iconColor: "#CAEA3E",
      reverseButtons: true,
      customClass: {
        popup: "swal-dark-popup",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });

    if (!isConfirmed) return;

    try {
      setCancelling(true);

      // (المسار الحالي كما عندك)
      const res = await axios.post(`${API_BASE_URL}/carts/status`,
        { cart_id: localOrder.cartId }
      );

      if (res?.data?.status === true) {
        onCancelSuccess?.(localOrder.cartId);
        onClose?.();

        await Swal.fire({
          icon: "success",
          title: "تم الإرسال",
          text: "تم إرسال طلب الإلغاء/الاسترجاع بنجاح.",
          confirmButtonText: "حسناً",
          confirmButtonColor: "#CAEA3E",
          iconColor: "#CAEA3E",
          customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
        });
      } else {
        await Swal.fire({
          icon: "info",
          title: "تعذر الإلغاء",
          text: "تعذر إلغاء الطلب حالياً.",
          confirmButtonText: "حسناً",
          confirmButtonColor: "#CAEA3E",
          iconColor: "#CAEA3E",
          customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
        });
      }
    } catch (e) {
      await Swal.fire({
        icon: "error",
        title: "حدث خطأ",
        text: "حدث خطأ أثناء الإلغاء.",
        confirmButtonText: "حسناً",
        confirmButtonColor: "#CAEA3E",
        iconColor: "#CAEA3E",
        customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
      });
    } finally {
      setCancelling(false);
    }
  };

  // إلغاء قطعة واحدة (يظهر فقط في جاري/اكتملت)
  const handleCancelItem = async (it) => {
    if (!localOrder?.cartId || !it?.id) {
      await Swal.fire({
        icon: "error",
        title: "بيانات غير مكتملة",
        text: "بيانات القطعة غير مكتملة.",
        confirmButtonText: "حسناً",
        confirmButtonColor: "#CAEA3E",
        iconColor: "#CAEA3E",
        customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
      });
      return;
    }

    const { isConfirmed } = await Swal.fire({
      icon: "warning",
      title: "تأكيد إلغاء القطعة",
      text: `هل تريد إلغاء القطعة «${it.name || it.id}»؟`,
      showCancelButton: true,
      confirmButtonText: "نعم، إلغاء القطعة",
      cancelButtonText: "تراجع",
      confirmButtonColor: "#CAEA3E",
      iconColor: "#CAEA3E",
      reverseButtons: true,
      customClass: {
        popup: "swal-dark-popup",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });

    if (!isConfirmed) return;

    try {
      setCancellingItemId(it.id);

      const res = await axios.post(`${API_BASE_URL}/cart-items/request-cancel`,
        { item_id: it.id }
      );

      if (res?.data?.status === true || res?.status === 200) {
        const items = (localOrder.items || []).filter((x) => x.id !== it.id);
        const deliveryFee = items.reduce(
          (s, x) => s + Number(x.delivery || 0) * Number(x.qty || 1),
          0
        );
        const subtotal = items.reduce(
          (s, x) => s + Number(x.price || 0) * Number(x.qty || 1),
          0
        );
        const grandTotal = subtotal + deliveryFee;

        const updated = { ...localOrder, items, deliveryFee, subtotal, grandTotal };
        setLocalOrder(updated);

        onItemCancelSuccess?.(localOrder.cartId, it.id, updated);

        if (items.length === 0) {
          onCancelSuccess?.(localOrder.cartId);
          onClose?.();
        }

        await Swal.fire({
          icon: "success",
          title: "تم الإرسال",
          text: "تم إرسال طلب إلغاء القطعة بنجاح.",
          confirmButtonText: "حسناً",
          confirmButtonColor: "#CAEA3E",
          iconColor: "#CAEA3E",
          customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
        });
      } else {
        await Swal.fire({
          icon: "info",
          title: "تعذّر الإلغاء",
          text: res?.data?.message || "تعذر إلغاء هذه القطعة.",
          confirmButtonText: "حسناً",
          confirmButtonColor: "#CAEA3E",
          iconColor: "#CAEA3E",
          customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
        });
      }
    } catch (e) {
      await Swal.fire({
        icon: "error",
        title: "حدث خطأ",
        text: "حدث خطأ أثناء إلغاء القطعة.",
        confirmButtonText: "حسناً",
        confirmButtonColor: "#CAEA3E",
        iconColor: "#CAEA3E",
        customClass: { popup: "swal-dark-popup", confirmButton: "swal-confirm-btn" },
      });
    } finally {
      setCancellingItemId(null);
    }
  };
  // Base site URL (override with REACT_APP_WEBSITE_URL if you have one)
  const WEBSITE_URL =
    (typeof process !== "undefined" && process.env?.REACT_APP_WEBSITE_URL) ||
    window.location.origin;

  const openPartDetails = (partId) => {
    if (!partId) return;
    window.location.assign(`${WEBSITE_URL}/part/${partId}`);
    // or: window.open(`${WEBSITE_URL}/part/${partId}`, "_self");
  };


  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="modal-window" dir="rtl" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <button className="modal-close" onClick={onClose} aria-label="إغلاق">×</button>
        </div>

        {/* marker to confirm correct component in DevTools */}
        {(() => {
          const items = localOrder.items ?? [];
          const showItemCancel = canCancel && items.length > 1;

          return (
            <>
              <div className="items-table" data-version="modal-v2">
                <div className="items-head">
                  <div>المنتج</div>
                  <div>السعر</div>
                  <div>الكمية</div>
                  <div>السعر الإجمالي</div>
                  {showItemCancel && <div>إجراء</div>}
                </div>

                {items.map((it) => (
                  <div
                    key={it.id}
                    className="items-row"
                    role="button"
                    tabIndex={0}
                    onClick={() => openPartDetails(it.part_id)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        openPartDetails(it.part_id);
                      }
                    }}
                    style={{ cursor: "pointer" }}
                    title="عرض تفاصيل القطعة"
                  >
                    <div className="prod">
                      <img src={it.image} alt={it.name} />
                      <div className="prod-name">{it.name}</div>
                    </div>
                    <div className="cell">{fmt(it.price)}</div>
                    <div className="cell">{it.qty}</div>
                    <div className="cell highlight">{fmt(it.price * it.qty)}</div>

                    {showItemCancel && (
                      <div className="cell" style={{ whiteSpace: "nowrap" }}>
                        <button
                          className="btn danger"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCancelItem(it);
                          }}
                          disabled={cancellingItemId === it.id}
                          style={{ padding: "6px 10px", fontSize: 12, borderRadius: 8 }}
                          title="إلغاء هذه القطعة فقط"
                        >
                          {cancellingItemId === it.id ? "..." : "الغاء"}
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="order-meta">
                <div className="meta-col">
                  <div className="meta-line"><span className="k">قيمة التوصيل</span><span className="v">{fmt(localOrder.deliveryFee)}</span></div>
                  <div className="meta-line"><span className="k">إجمالي الفاتورة</span><span className="v">{fmt(localOrder.grandTotal)}</span></div>
                  <div className="meta-line"><span className="k">ID الطلبية</span><span className="v">{localOrder.cartId}</span></div>
                </div>
                <div className="meta-col">
                  <div className="meta-line"><span className="k">اسم المستلم</span><span className="v">{localOrder.recipientName}</span></div>
                  <div className="meta-line"><span className="k">رقم المستلم</span><span className="v">{localOrder.recipientPhone}</span></div>
                  <div className="meta-line"><span className="k">{dateLabel}</span><span className="v">{localOrder.arrivalAt}</span></div>
                  <div className="meta-line"><span className="k">حالة الطلبيه</span><span className="v">{statusLabel}</span></div>
                </div>
              </div>

              <div className="modal-actions" style={{ display: "flex", gap: 10 }}>
                {canConfirmReceived && (
                  <button className="btn pill" onClick={handleConfirmReceived} disabled={confirming || disableConfirmReceived}>
                    {confirming ? "..." : "استلمت طلبيتي"}
                  </button>
                )}

                {canCancel && (
                  <button className="btn danger" onClick={handleCancel} disabled={cancelling}>
                    {cancelling ? "..." : "الغاء الطلب"}
                  </button>
                )}
              </div>
            </>
          );
        })()}
      </div>
    </div>
  );

}

